import React from 'react';
import { Section } from './ui/Section';
import { FAQItem } from '../types';

const faqData: FAQItem[] = [
  {
    question: "Is this a commercial product?",
    answer: "No. LeadFraud.org is a standards and research initiative, not a sales motion."
  },
  {
    question: "Who is this for?",
    answer: "Revenue leaders, data buyers, honest vendors, and operators who want a clearer, more truthful foundation for go-to-market decisions."
  },
  {
    question: "What do I get by joining the list?",
    answer: "Early access to our reports and standards drafts on lead creation practices, including content syndication."
  }
];

export const FAQ: React.FC = () => {
  return (
    <Section className="bg-[#FAFAFA]">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-16 border-t border-gray-300 pt-16">
        {faqData.map((item, index) => (
          <div key={index} className="flex flex-col gap-4">
            <h3 className="text-xl font-serif text-primary">
              {item.question}
            </h3>
            <p className="text-base text-secondary font-light font-sans leading-relaxed">
              {item.answer}
            </p>
          </div>
        ))}
      </div>
    </Section>
  );
};